import React                                                        from 'react';
import { withStyles }                                               from '@material-ui/core/styles';
import {colores,funciones}                                from '../../global';
import AuthService                                                  from '../../AuthService';
import CircularProgress                                             from '@material-ui/core/CircularProgress';
import Backdrop                                                     from '@material-ui/core/Backdrop';
import Icono                                                        from '../../components/Icono'
import '../../CSS/Style_principal.css'
import { Avatar } from '@material-ui/core';

let Auth = new AuthService();
var movil=/Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent);
var movil_pequeño=/Android|webOS|iPhone|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent);

/*                           CLASES DE ESTILO                       */

var styles = theme =>({
    backdrop: {
      zIndex: 500000,
      color: '#fff', 
      flexDirection: 'column'
    },
    })

/*                                        EXPORT                                      */
export default withStyles(styles)(
    class Campaña_ISO extends React.Component {
      tablaRef = React.createRef();

      constructor(props) {
        super(props);
        this.l= props.l
        this.e= props.e
        this.i= props.i
        this.actualizarbarra=props.actualizarbarra
        this.actualizarcircular=props.actualizarcircular

        this.state = {
            openBackDrop:      false, 
            isLoggin:          undefined,
            heightTableMain:    0,
            rows: [],
            selection: [],
            grouping: [],
            expandedGroups: [],
            filteringColumnExtensions: [],
            filters: [],
            expandedRowIds: [],
            enabledFilterRows: true
        }
        
    }; //FIN CONSTRUCTORS



componentDidMount()
{
        let _this = this;
        _this.actualizarbarra(false)

        Auth.loggedIn().then( function(b){
            _this.setState({ isLoggin: b})
            if(b){
              _this.setState({ heightTableMain:   funciones.getHeightTableMain(movil_pequeño,_this).heightTable})
            }
            _this.actualizarbarra(true)
        })
}

/*                                          RENDER                          */
render() {
    const { classes } = this.props;


    if (this.state.isLoggin === true )
    {
    return (    
    <React.Fragment>
      <Backdrop className={classes.backdrop}  open={this.state.openBackDrop}>
          <CircularProgress color="inherit" />
          <span style={{ marginTop: '10px' }}>{this.state.open_seleccion?'Guardando...':this.state.open_borrar?'Eliminando...':''}</span>
      </Backdrop>

      <div ref={this.tablaRef} style={{background:'white'}}>
        {movil?
        <div  style={{height:this.state.heightTableMain,display:'flex',alignItems: 'center',justifyContent:'center'}}>
            <div align='center' style={{display:'block'}}>
            <Avatar style={{margin:5,background: colores.azul,borderRadius:15}}><Icono icono="Drive" /></Avatar>           
            <a  href='/DOC200214-20022014181035.pdf' target="_blank">DOC200214  PDF  File</a>
            </div>
        </div>:
        <object type="application/pdf" data={'/DOC200214-20022014181035.pdf'}   height={this.state.heightTableMain} width="100%">
        <embed src="/DOC200214-20022014181035.pdf" aria-labelledby='ISO' type="application/pdf" />    
        </object> 
        }
      </div>
    </React.Fragment>
    ); /// finaliza return
    }
    else if (this.state.isLoggin === false)
    {
        Auth.logout()
        window.location.reload();
        return; 
    }
    return null;
} /// finaliza render
} /// finaliza class
)/// finaliza withStyles

    

    